export default __webpack_public_path__ + "static/media/cleaning-trash.6ba58f36.jpeg";